import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { SessionQueryProvider } from './providers/SessionQueryProvider';
import './i18n';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import { AuthProvider } from './providers/AuthProvider';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider clerkKey={PUBLISHABLE_KEY}>
      <SessionQueryProvider>
        <Theme>
           <App />
        </Theme>
      </SessionQueryProvider>
    </AuthProvider>
  </React.StrictMode>,
);
